import { InjectionToken } from '@angular/core';
import { IAscModuleDefinition } from '../i-asc-module-definition';
import { IamClientModuleConfiguration } from './model/iam-client-module-configuration';


export const MODULE_CONFIGURATION = new InjectionToken<IamClientModuleConfiguration>('module configuration');

export const IAM_DEFINITION: IAscModuleDefinition = {
   moduleId: 'IAM',
   displayName: 'Geschäftsidentitäten',
   moduleRoute: {
      path: 'iam',
      loadChildren: () => import('src/modules/iam/iam.module').then(m => m.IamModule)
   }
};

export const IAM_ROUTE_PATH = {
   EDIT: 'edit',
   NEW_CREATE: 'new-create',
   NEW_UPDATE: 'new-update',
   NEW_DELETE: 'new-delete',
   APPLICATIONS: 'applications'
};

export const IAM_FORM_INTENTS = {
   NEW_CREATE: 'new-create',
   NEW_UPDATE: 'new-update',
   NEW_DELETE: 'new-delete'
};
